<div class="pl-5 py-5 flex h-[calc(100svh-80px)] overflow-hidden gap-[2%]" *transloco="let t">
  
  @if(showModalEvent){
  <std-modal [closeOnOutside]="false" [show]="showModalEvent" (close)="showModalEvent = false">
    <div header class="text-white font-semibold">Crea turno</div>
    <div content class="min-w-[350px]">
      <std-select direction="down" (onChangeValue)="changeSelectShift($event,'selectedEmployee')" class="max-w-[400px]"
        typeOfFiltrableSelect="includes" customLabel="label-input" [filterable]="true"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" label="Dipendente" bindValue="id"
        bindLabel="completeName" customClassContaier="border-primary custom-select" placeholder="Seleziona dipendente"
        [data]="employees"></std-select>
      
      @if(shift['selectedEmployee']){ 
      <std-select direction="down" (onChangeValue)="changeSelectShift($event,'selectedJob')"
        class="max-w-[400px]" typeOfFiltrableSelect="includes" customLabel="label-input" [filterable]="true"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" label="Mansione" bindValue="id"
        bindLabel="name" customClassContaier="border-primary custom-select" placeholder="Seleziona mansione"
        [data]="jobsEmployee"></std-select>
      }
      
      <div class="w-full">
        <div (click)="showStart = true">
          <div class="pointer-events-none">
            <std-input customLabel="label-input mt-2" customInputClass="custom-input"
              type="text" labelPosition="top" [placeholder]="t('common.from')" [label]="t('common.from')"
              [(ngModel)]="shift.startDateShow"></std-input>
          </div>
        </div>
      </div>
      
      <div class="w-full">
        <div (click)="showEnd = true">
          <div class="pointer-events-none">
            <std-input customLabel="label-input mt-2" customInputClass="custom-input"
              type="text" labelPosition="top" [placeholder]="t('common.to')" [label]="t('common.to')"
              [(ngModel)]="shift.endDateShow"></std-input>
          </div>
        </div>
      </div>
      
      <div class="w-full mt-4"
        [ngClass]="{'opacity-35 pointer-events-none': !shift.startDate || !shift.endDate || !shift.selectedJob || !shift.selectedEmployee }">
        <std-button (click)="confirmModal()" size="sm">{{t('common.addEvent')}}</std-button>
      </div>
    </div>
  </std-modal>
  }

  @if(showModalCreateCalendar){
  <std-modal [closeOnOutside]="false" [show]="showModalCreateCalendar" (close)="showModalCreateCalendar = false">
    <div header class="text-white font-semibold">Crea calendario</div>
    <div content class="max-w-[350px]">
      <div class="label-input">
        @if(currentCalendarMode == 'weekly' && !selectedEmployee.id && !selectedJob.id){
          Proseguendo il calendario della settimana attuale sarà sovrascritto e sostituito con un calendario generato automaticamente in base ai parametri del punto vendita
        }
        @if(currentCalendarMode !== 'weekly' || selectedEmployee.id || selectedJob.id){
          La funzione crea calendario è disponibile solo nella versione settimanale e senza filtri attivi
        }
      </div>
      <div class="w-full mt-4">
        @if(currentCalendarMode == 'weekly' && !selectedEmployee.id && !selectedJob.id){
          <std-button (click)="createCalendar()" size="sm">Crea calendario</std-button>
        }
      </div>
    </div>
  </std-modal>
  }

  <div class="w-full testing h-full flex flex-col" [ngClass]="{'!w-[70%]': showAlerts}">
    
    <div class="bg-white p-5 rounded-xl shadow-sm border border-gray-200 flex flex-wrap gap-6 items-end relative z-[60] mb-6 flex-shrink-0">
      
      @if(showSelectFilters){
        <std-select direction="down" (onChangeValue)="changeSelect($event,'selectedStore')" class="w-[240px]"
          typeOfFiltrableSelect="includes" 
          customLabel="text-sm font-semibold text-gray-800 mb-1 block" 
          [filterable]="true"
          customClassContainerElement="max-h-[250px] overflow-y-auto bg-white shadow-2xl border border-gray-200 rounded-lg z-[100]" 
          label="Punto vendita"
          bindValue="id" bindLabel="name" 
          customClassContaier="bg-gray-50 border border-gray-200 rounded-lg"
          placeholder="Seleziona punto vendita" [data]="stores"></std-select>

        <std-select direction="down" (onChangeValue)="changeSelect($event,'selectedJob')" class="w-[240px]"
          typeOfFiltrableSelect="includes" 
          customLabel="text-sm font-semibold text-gray-800 mb-1 block" 
          [filterable]="true"
          customClassContainerElement="max-h-[250px] overflow-y-auto bg-white shadow-2xl border border-gray-200 rounded-lg z-[100]" 
          label="Mansione" bindValue="id"
          bindLabel="name" 
          customClassContaier="bg-gray-50 border border-gray-200 rounded-lg" 
          placeholder="Seleziona mansione"
          [data]="jobs"></std-select>

        <std-select direction="down" (onChangeValue)="changeSelect($event,'selectedEmployee')" class="w-[240px]"
          typeOfFiltrableSelect="includes" 
          customLabel="text-sm font-semibold text-gray-800 mb-1 block" 
          [filterable]="true"
          customClassContainerElement="max-h-[250px] overflow-y-auto bg-white shadow-2xl border border-gray-200 rounded-lg z-[100]" 
          label="Dipendente" bindValue="id"
          bindLabel="completeName" 
          customClassContaier="bg-gray-50 border border-gray-200 rounded-lg" 
          placeholder="Seleziona dipendente"
          [data]="employees"></std-select>
      }

      @if(showCalendar && (selectedStore?.id || selectedJob?.id || selectedEmployee?.id)){
        <std-button (click)="resetFilters()" class="shadow-sm">Resetta filtri</std-button>
      }

      <!-- @if(!showAlerts && alerts.length > 0 && currentCalendarMode == 'weekly' && !selectedJob?.id && !selectedEmployee?.id){
        <div (click)="showAlerts = true"
          class="rounded-full select-none bg-red-50 border border-red-200 text-red-600 font-bold text-[18px] relative flex items-center place-content-center size-11 ml-auto cursor-pointer hover:bg-red-100 transition-colors shadow-sm">
          {{alerts.length}}!
        </div>
      } -->
    </div>

    <div class="flex-grow overflow-x-auto custom-scrollbar bg-gray-50 rounded-xl">
      @if(showCalendar){
        
        <div class="min-w-[1180px] p-2 flex flex-col min-h-full">
          
          <div class="flex items-center justify-start gap-12 bg-white px-5 py-3 rounded-xl shadow-sm border border-gray-200 mb-4 flex-shrink-0">
            <div class="flex items-center gap-6 flex-shrink-0">
              <button (click)="goToPrevious()" class="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 transition-colors text-gray-800 font-bold text-xl cursor-pointer border-0 outline-none">
                &lt;
              </button>
              <span class="text-xl font-bold text-gray-900 tracking-tight whitespace-nowrap">{{ formattedDateRange }}</span>
              <button (click)="goToNext()" class="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 transition-colors text-gray-800 font-bold text-xl cursor-pointer border-0 outline-none">
                &gt;
              </button>
            </div>

            <div class="flex items-center gap-3 flex-shrink-0 ml-4">
              <span class="text-xs font-bold uppercase tracking-wider transition-colors" [ngClass]="currentCalendarMode === 'weekly' ? 'text-primary' : 'text-gray-400'">Settimanale</span>
              
              <std-toggle 
                [checked]="currentCalendarMode === 'daily'" 
                (onValueChange)="toggleViewMode($event)">
              </std-toggle>

              <span class="text-xs font-bold uppercase tracking-wider transition-colors" [ngClass]="currentCalendarMode === 'daily' ? 'text-primary' : 'text-gray-400'">Giornaliero</span>
            </div>
          </div>

          <div class="flex-grow">
            <div *ngFor="let day of realSchedule; let i = index; trackBy: trackByDay" [class.mt-8]="i > 0" class="bg-white shadow-md rounded-lg text-xs border border-gray-800 overflow-hidden">
              
              <div class="grid bg-gray-200 border-b border-gray-800 font-bold sticky top-0 z-40"
                   style="grid-template-columns: minmax(140px, 1.5fr) repeat(28, minmax(35px, 1fr)) minmax(60px, 0.5fr);">
                <div class="px-1 py-2 border-r border-gray-800 flex items-center justify-center bg-white font-bold text-center border-l-4 border-gray-800 z-50 sticky left-0" style="grid-column: 1;">
                  {{ day.dayOfWeek }}
                </div>
                <div *ngFor="let time of timeSlots"
                  class="border-gray-800 text-center py-2 flex items-center justify-center relative z-40">
                  <div class="absolute left-0 h-0 w-0 flex items-center place-content-center -rotate-90">
                    <div class="flex items-center gap-1 place-content-start"><div class="w-[14px] h-[4px] bg-black"></div>
                    <span class="inline-block whitespace-nowrap text-xs">{{ time }}</span></div>
                  </div>
                </div>
                <div class="px-1 py-2 text-center border-l border-gray-800 flex items-center justify-center bg-gray-200 sticky right-0 z-50 border-r-4 border-gray-800" style="grid-column: 30;">
                  TOT Ore
                </div>
              </div>

              <div *ngFor="let emp of day.employeeShifts; trackBy: trackByEmployee" class="grid border-b border-gray-800 hover:bg-gray-50 relative h-12"
                   style="grid-template-columns: minmax(140px, 1.5fr) repeat(28, minmax(35px, 1fr)) minmax(60px, 0.5fr);">
                
                <div class="px-1 py-2 font-medium border-r-2 border-l-4 border-gray-800 border-b border-b-gray-800 bg-white flex items-center sticky left-0 z-30" style="grid-column: 1; grid-row: 1;">
                  {{ emp.firstName }} {{ emp.lastName }}
                </div>

                <ng-container *ngFor="let shift of emp.shifts; trackBy: trackByShift">
                  <div [ngClass]="getShiftClass(shift)" [ngStyle]="getShiftStyle(shift)" class="h-full self-center rounded shadow-sm text-[11px] flex items-center justify-center overflow-hidden z-10 cursor-pointer" [title]="shift.startTime + ' - ' + shift.endTime">
                    <span *ngIf="shift.type !== 'WORK'" class="leading-tight">{{ shift.label }}</span>
                  </div>
                </ng-container>

                <div class="col-start-2 col-end-[30] row-start-1 grid grid-cols-[repeat(28,minmax(0,1fr))] z-0 pointer-events-none">
                  <div *ngFor="let _ of timeSlots" class="h-full border-r border-gray-400"></div>
                </div>

                <div class="px-1 py-2 font-bold text-center border-l-2 border-r-4 border-gray-800 border-b border-b-gray-800 bg-white flex items-center justify-center sticky right-0 z-30" style="grid-column: 30; grid-row: 1;">
                  {{ emp.totalHours > 0 ? emp.totalHours.toFixed(1) : '' }}
                </div>
                
              </div>
            </div>
          </div>
        </div>
      }
      
      @if(!showCalendar){
        <div class="text-[48px] font-semibold text-primary mt-10 ml-10">Seleziona un punto vendita</div>
      }
    </div>
  </div>

  <div class="w-[2px] bg-primary rounded-full flex-shrink-0"></div>
  @if(showAlerts){
    <div class="w-[25%] border-primary flex-shrink-0">
      <div class="text-primary text-title font-semibold flex place-content-between items-center">
        <div>AVVISI</div>
        <div (click)="showAlerts = false" class="text-[40px] font-bold cursor-pointer">→</div>
      </div>
      <div class="h-[calc(100svh-180px)] overflow-y-auto custom-scroll pr-2">
        @for (alert of alerts; track $index) {
          }
      </div>
    </div>
  }
</div>